module.exports = __webpack_public_path__ + "img/logo.41f0f782.png";